export const HOWMANY_SUBSCRIPTIONS = 15;
